const data = {
  id: 0,
  curation: require("./4/curation").default,
};

export default data;
